<template>
    <header
        class="l-section__header"
        v-view.once
    >
        <div v-if="logo">
            <h3 class="l-section__small | t-s mb-2">Une initiative de</h3>
            <a href="https://vivreenville.org" title="Vivre en Ville" class="l-section__logo" target="_blank" rel="noopener">
                <Icon
                    icon="vev"
                />
            </a>
        </div>
        <h2
            v-if="subtitle"
            class="l-section__sub | t-t3"
        >
            <span v-html="subtitle"></span>
        </h2>
        <h3
            v-if="title"
            class="l-section__title | t-t1"
        >
            <span v-html="title"></span>
        </h3>
    </header>
</template>

<script>
import Icon from 'templates/objects/Icon';

export default {
    name: 'block-header',
    components: {
        Icon,
    },
    props: {
        logo: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
        },
        subtitle: {
            type: String,
        },
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>

    .l-section__header {

        > * {
            opacity: 0;
            transform: translate(0, .2em);
        }

        &.view-in {

            & > * {
                opacity: 1;
                transform: translate(0);

                @for $i from 1 to 4 {

                    &:nth-child(#{$i}) {
                        $i: $i - 1;
                        transition: all #{.4}s $out-sine #{$i/10}s;
                    }
                }
            }
        }
    }

</style>
